(function () {
  'use strict';
  function initialize(root) {
    root.querySelectorAll('[data-event-form-details]').forEach(function (details) {
      if (details.dataset.initialized) return;
      details.dataset.initialized = 'true';
      var form = details.closest('form');
      var summary = details.querySelector('summary');
      var panel = details.querySelector('.event-inquiry__details-content');
      var title = details.querySelector('[data-event-disclosure-title]');
      var animation;
      var expanded = true;
      var basics = Array.from(form.querySelectorAll('input[name="contact[name]"], input[name="contact[phone]"], input[name="contact[email]"]'));
      function hasValue(field) { return Boolean(field.value.trim()); }
      function setExpanded(next, immediate) {
        if (next === expanded && !immediate) return;
        var startHeight = details.open ? panel.getBoundingClientRect().height : 0;
        if (animation) { animation.cancel(); animation = null; }
        expanded = next;
        summary.setAttribute('aria-expanded', String(next));
        title.textContent = next ? 'A little more about your event' : 'Continue your inquiry';
        details.classList.toggle('is-expanded', next);
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (immediate || reducedMotion || typeof panel.animate !== 'function') {
          details.open = next;
          panel.style.overflow = '';
          return;
        }
        details.open = true;
        panel.style.overflow = 'hidden';
        animation = panel.animate([
          { height: startHeight + 'px', opacity: next ? 0 : 1 },
          { height: (next ? panel.scrollHeight : 0) + 'px', opacity: next ? 1 : 0 }
        ], { duration: next ? 620 : 380, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
        animation.onfinish = function () {
          details.open = next;
          panel.style.overflow = '';
          animation = null;
        };
      }
      function revealIfStarted() { if (basics.some(hasValue)) setExpanded(true); }
      // Keep restored values and server validation errors visible. Without JS,
      // the native disclosure starts open so every required field is reachable.
      setExpanded(details.hasAttribute('data-form-errors') || basics.some(hasValue) || Array.from(details.querySelectorAll('input, select, textarea')).some(hasValue), true);
      summary.addEventListener('click', function (event) { event.preventDefault(); setExpanded(!expanded); });
      basics.forEach(function (field) {
        field.addEventListener('input', revealIfStarted);
        field.addEventListener('change', revealIfStarted);
        field.addEventListener('focus', revealIfStarted);
      });
      // Native validation must be able to focus a required field after a visitor
      // manually closes the disclosure and submits using Enter.
      form.addEventListener('invalid', function (event) {
        if (details.contains(event.target)) setExpanded(true, true);
      }, true);
      window.addEventListener('pageshow', revealIfStarted);
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
